import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import i18n from '../i18n';

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      const t = i18n.t.bind(i18n);
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-8">
          <div className="text-5xl mb-4">{'\u{1F527}'}</div>
          <h2 className="text-xl font-bold text-(--color-text-primary) mb-2">
            {t('errors.somethingWrong')}
          </h2>
          <p className="text-(--color-text-secondary) mb-4">
            {t('errors.unexpectedError')}
          </p>
          <button
            onClick={() => this.setState({ hasError: false })}
            className="px-4 py-2 bg-green-400 text-gray-900 rounded-lg font-semibold hover:bg-green-300 transition-colors"
          >
            {t('errors.tryAgain')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
